import { callAll } from "../../../utils/call-all";
import { useScrollBarContext } from "../scroll-bar.context";
import styles from "../scroll-bar.module.scss";
import type { ScrollBarTrackProps } from "../types-scroll-bar";

export function ScrollBarTrack({ className, onPointerDown, ...rest }: ScrollBarTrackProps) {
  const { onTrackPointerDown, partTestId } = useScrollBarContext();

  return (
    <div
      className={[styles.track, className].filter(Boolean).join(" ")}
      data-testid={partTestId("track")}
      {...rest}
      onPointerDown={callAll(onTrackPointerDown, onPointerDown)}
    />
  );
}
ScrollBarTrack.displayName = "ScrollBar.Track";
